import { render, staticRenderFns } from "./SFDCEmails.vue?vue&type=template&id=f0b6892a"
import script from "./SFDCEmails.vue?vue&type=script&lang=js"
export * from "./SFDCEmails.vue?vue&type=script&lang=js"
import style0 from "./SFDCEmails.vue?vue&type=style&index=0&id=f0b6892a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports